import { Action } from 'redux';
import { ContractBranch } from '../../../models/Entities/Contracts/ContractBranch';
import { ContractBranchState, ContractBranchUnloadState } from '../../states/ContractBranchState';


export default function ContractBranchesCreateReducer(
  state: ContractBranchState | undefined,
  action: Action
): ContractBranchState {
  const currentState = state ?? ContractBranchUnloadState;
  const a: any = action;
  let CurrentBranchContract: ContractBranch | undefined;

  switch (a.type) {
    case 'CONTRACTBRANCH_CREATE_REQUEST_ACTION':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
      };
    
    case 'CONTRACTBRANCH_CREATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
      };
    
    case 'CONTRACTBRANCH_CREATE_ERROR_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}